<div class="widget-chatbot-wrapper">

  <!-- Chat Window -->
  <div class="chatbot-window"
       test-id="widget-chatbot-window"
       [class.open]="open"
       [class.maximized]="isMaximized">
    <div class="chat-header">
      <button class="newChat-button"
              *ngIf="showNewChatButton"
              (click)="newChat()"
              [disabled]="isRequestInProgress || showDisclaimer">
        <em class="fa-light fa-plus-circle icon-plus"></em>
        <span class="label-text">{{ 'CHATBOT.new_chat' | translate }}</span>
      </button>

      <div class="icon">
        <img [src]="chatIconSrc" [alt]="chatIconAlt" width="32" height="32">
      </div>
      <span class="label">{{ chatbotName }}</span>

      <div class="header-buttons">
        <button class="maximize-minimize-button"
                (click)="toggleMaximize()"
                [tooltip]="isMaximized ? ('CHATBOT.minimize' | translate) : ('CHATBOT.maximize' | translate)"
                [placement]="'left'"
                [disabled]="showDisclaimer">
          <em [ngClass]="isMaximized ? 'fa fa-light fa-down-left-and-up-right-to-center' : 'fa fa-light fa-up-right-and-down-left-from-center'"></em>
        </button>
        <button class="close-chat-button"
                (click)="toggleChatbot()"
                tooltip="{{'CHATBOT.close_chat' | translate}}"
                placement="left">
          <em class="fa fa-light fa-times"></em>
        </button>
      </div>
    </div>

    <div class="chatbot-body" #scrollContainer (scroll)="onChatScroll()">
      <div class="chatbot-messages" *ngIf="!showDisclaimer">
        <div class="message"
             *ngFor="let msg of messages"
             [ngClass]="[msg.sender, msg.loading ? 'loading' : '']"
             #messageItem>
          <div class="bubble">
            <!-- GRAPH -->
            <ng-container *ngIf="msg.responseType === ResponseType.CHART; else textOnly">
              <div class="chart-container">
                <gp-echart [options]="msg.chartContent" [width]="getChartWidth(msg.chartContent)" [height]="'400px'"></gp-echart>
              </div>
              <div class="text-container">
                {{ msg.text }}
              </div>
            </ng-container>

            <!-- TEXT -->
            <ng-template #textOnly>
              {{ msg.text }}
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Disclaimer message before using chat -->
      <div class="disclaimer-overlay" *ngIf="showDisclaimer">
        <div class="disclaimer-box">
          <h2 class="disclaimer-header">{{
              'CHATBOT_DISCLAIMER' | translate: {
                chatbotName: chatbotName
              }
            }}</h2>

          <div class="disclaimer-body">
            <p
              [innerHTML]="'CHATBOT_DISCLAIMER.welcome_message' | translate: {
              chatbotName: getBoldText(chatbotName),
              productName: getBoldText(productName),
              }">
            </p>
            <p>
              {{'CHATBOT_DISCLAIMER.important_note' | translate}}
            </p>
            <p class="footnote"
              [innerHTML]="'CHATBOT_DISCLAIMER.footnote' | translate: {
              chatbotName: getBoldText(chatbotName)
              }">
            </p>
          </div>

          <div class="disclaimer-actions">
            <button class="btn btn-sm btn-secondary p-x-md" (click)="refuseDisclaimer()">
              <em class="fa-regular fa-xmark-large"></em>
              <em>
                {{'CHATBOT_DISCLAIMER.not_interested' | translate}}
              </em>
            </button>
            <button class="btn btn-sm btn-primary p-x-md" (click)="acceptDisclaimer()">
              <em class="fa-regular fa-circle-check"></em>
              <em>
                {{
                  'CHATBOT_DISCLAIMER.start_using' | translate: {
                    chatbotName: chatbotName
                  }
                }}
              </em>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- RECOMMENDATIONS (if, any) -->
    <div class="recommendations-section" *ngIf="currentRecommendations?.length">
      <div class="recommendations-header" (click)="toggleRecommendations()">
        <i class="fa-light" [ngClass]="areRecommendationsExpanded ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        <span>
          {{ 'CHATBOT.suggestions' | translate }}
        </span>
      </div>
      <div class="recommendations-content" [class.expanded]="areRecommendationsExpanded">
        <button type="button" class="recommendation-chip"
                [disabled]="isRequestInProgress"
                *ngFor="let rec of currentRecommendations"
                (click)="onRecommendationClicked(rec)">
          {{ rec }}
        </button>
      </div>
    </div>

    <div class="chatbot-footer-container">
      <button class="scroll-down-button"
              [ngClass]="{ 'visible': !showDisclaimer && !isAtChatBottom }"
              (click)="scrollToBottom()">
        <em class="fa-regular fa-chevrons-down"></em>
      </button>

      <div class="chatbot-input">
         <span class="footer-disclaimer">
           {{ isFeedbackMode ? ('CHATBOT_FEEDBACK.footer_disclaimer' | translate) : ('CHATBOT.footer_disclaimer' | translate) }}
         </span>
        <textarea
          #chatInput
          [formControl]="newMessage"
          (keyup.enter)="isFeedbackMode ? sendFeedback() : sendMessage()"
          (input)="adjustTextareaHeight()"
          [placeholder]="isFeedbackMode ? ('CHATBOT_FEEDBACK.type_your_feedback' | translate) : ('CHATBOT.type_your_message' | translate)">
        </textarea>
        <div class="chatbot-actions" [class.confirm]="isFeedbackMode && isDiscardConfirmed">

          <!-- When confirming discard -->
          <ng-container *ngIf="isFeedbackMode && isDiscardConfirmed; else normalActions">
            <span class="confirm-hint">{{ 'CHATBOT_FEEDBACK.confirmation_hint' | translate }}</span>

            <button class="feedback-button center keep-editing-btn"
                    (click)="keepEditing()"
                    [disabled]="isRequestInProgress || showDisclaimer">
              {{ 'CHATBOT_FEEDBACK.keep_editing' | translate }}
            </button>

            <button class="send-button"
                    (click)="confirmDiscard()"
                    [disabled]="isRequestInProgress || showDisclaimer">
              <em class="fa-regular fa-xmark-large"></em>
              {{ 'CHATBOT_FEEDBACK.discard' | translate }}
            </button>
          </ng-container>

          <!-- Normal actions (chat or feedback mode) -->
          <ng-template #normalActions>
            <button class="feedback-button"
                    [ngClass]="{ 'discard-mode': isFeedbackMode, 'send-feedback-mode': !isFeedbackMode }"
                    (click)="isFeedbackMode ? onDiscardClicked() : startFeedbackMode()"
                    [disabled]="isRequestInProgress || showDisclaimer">
              <em [ngClass]="isFeedbackMode ? 'fa-regular fa-xmark-large icon-primary' : 'fa fa-envelope-open icon-primary'"></em>
              {{ isFeedbackMode ? ('CHATBOT_FEEDBACK.discard' | translate) : ('CHATBOT_FEEDBACK.send_feedback' | translate) }}
            </button>

            <button class="send-button"
                    (click)="isFeedbackMode ? sendFeedback() : sendMessage()"
                    [disabled]="isRequestInProgress || showDisclaimer || !newMessage.value?.trim()">
              <em [ngClass]="isFeedbackMode ? 'fa fa-envelope-open' : 'fa fa-paper-plane-top'"></em>
              {{ isFeedbackMode ? ('CHATBOT_FEEDBACK.send_feedback' | translate) : ('CHATBOT.send' | translate) }}
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
